import React, { useState } from "react";
import axiosInstance from "../../../../../services/AxiosInstance";
import { notifySuccess, notifyError } from "jsx/components/CitoPlus/components/CitoPlusToastr";
import { Modal, Button, Form } from "react-bootstrap";

const IMPORT_URL = "/api/v3/zonas-sociales/activos/importar/";

const ActivosImportar = ({ show, onHide, onSuccess }) => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!file) {
      notifyError("Selecciona un archivo para importar.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("dry_run", "false"); // Siempre importar real, no validar

    setLoading(true);
    setResult(null);
    try {
      const response = await axiosInstance.post(IMPORT_URL, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setResult(response.data);
      notifySuccess("Importación completada exitosamente.");
      if (typeof onSuccess === "function") {
        onSuccess();
      }
      // Limpiar después de éxito
      setTimeout(() => {
        setFile(null);
        setResult(null);
        onHide();
      }, 2000);
    } catch (error) {
      let message =
        "No fue posible procesar la importación. Verifica el archivo y vuelve a intentarlo.";
      if (error.response && error.response.data) {
        try {
          message = JSON.stringify(error.response.data);
        } catch {
          // noop
        }
      }
      notifyError(message);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setFile(null);
    setResult(null);
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="fas fa-file-import me-2 text-primary" />
          Importar Activos
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <div className="mb-3">
            <Form.Label>
              Archivo (CSV/XLSX) <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="file"
              onChange={(e) => setFile(e.target.files?.[0] || null)}
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              disabled={loading}
            />
            <Form.Text className="text-muted">
              El archivo debe contener las columnas indicadas abajo. Las categorías se crearán automáticamente si no existen.
            </Form.Text>
          </div>

          <div className="alert alert-info">
            <h6 className="alert-heading">
              <i className="fas fa-info-circle me-2" />
              Formato esperado
            </h6>
            <p className="small mb-2">
              El archivo CSV debe tener las siguientes columnas:
            </p>
            <div className="table-responsive">
              <table className="table table-sm table-bordered border-dark">
                <thead className="table-dark">
                  <tr className="text-center">
                    <th>nombre</th>
                    <th>cantidad</th>
                    <th>estado</th>
                    <th>categoria</th>
                    <th>zona</th>
                    <th>costo</th>
                    <th>fecha_adquisicion</th>
                    <th>garantia_hasta</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><small>Silla de escritorio</small></td>
                    <td><small>10</small></td>
                    <td><small>bueno</small></td>
                    <td><small>Mobiliario</small></td>
                    <td><small>Zona Social Principal</small></td>
                    <td><small>150.00</small></td>
                    <td><small>2024-01-15</small></td>
                    <td><small>2026-01-15</small></td>
                  </tr>
                  <tr>
                    <td><small>Mesa de reuniones</small></td>
                    <td><small>2</small></td>
                    <td><small>nuevo</small></td>
                    <td><small>Mobiliario</small></td>
                    <td><small>Salón de Eventos</small></td>
                    <td><small>800.00</small></td>
                    <td><small>2024-02-20</small></td>
                    <td><small>2027-02-20</small></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="small mt-2">
              <strong>Campos obligatorios:</strong> nombre, cantidad, estado
              <br />
              <strong>Estados permitidos:</strong> nuevo, bueno, reparacion, dado_de_baja
              <br />
              <strong>Notas:</strong>
              <ul className="mb-0 mt-1">
                <li><strong>categoria:</strong> Nombre de la categoría. Se creará automáticamente si no existe.</li>
                <li><strong>zona:</strong> Nombre exacto de una zona social existente.</li>
                <li><strong>fecha_adquisicion / garantia_hasta:</strong> Formato YYYY-MM-DD (ej: 2024-01-15)</li>
                <li>Todos los demás campos son opcionales</li>
              </ul>
            </div>
          </div>

          {result && (
            <div className="alert alert-info">
              <h6 className="alert-heading">Resultado de la importación</h6>
              {"rows_total" in result && (
                <p className="mb-1">
                  <strong>Total de filas:</strong> {result.rows_total}
                </p>
              )}
              {"rows_valid" in result && (
                <p className="mb-1">
                  <strong>Filas válidas:</strong> {result.rows_valid}
                </p>
              )}
              {"rows_invalid" in result && (
                <p className="mb-1">
                  <strong>Filas con error:</strong> {result.rows_invalid}
                </p>
              )}
              {"job_id" in result && (
                <p className="mb-0">
                  <strong>Job ID:</strong> {result.job_id} ·{" "}
                  <strong>Estado:</strong> {result.status}
                </p>
              )}

              {Array.isArray(result.errors) && result.errors.length > 0 && (
                <div className="mt-3">
                  <h6>Errores por fila</h6>
                  <div className="table-responsive">
                    <table className="table table-sm table-striped">
                      <thead>
                        <tr>
                          <th>Fila</th>
                          <th>Errores</th>
                        </tr>
                      </thead>
                      <tbody>
                        {result.errors.map((err, idx) => (
                          <tr key={idx}>
                            <td>{err.row}</td>
                            <td>
                              {Array.isArray(err.errors)
                                ? err.errors.join("; ")
                                : String(err.errors || "")}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={handleClose}
            disabled={loading}
          >
            Cancelar
          </Button>
          <Button
            variant="primary"
            size="sm"
            type="submit"
            disabled={loading || !file}
          >
            {loading ? (
              <span className="d-inline-flex align-items-center gap-2">
                <i className="fas fa-circle-notch fa-spin" />
                <span>Importando...</span>
              </span>
            ) : (
              <>
                <i className="fas fa-file-import me-2" />
                Importar
              </>
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ActivosImportar;
